import React, { useState, useEffect } from "react";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import { isEmbedMode } from "../App";
import SelectedOption from "../component/selected_options";
import Search from "../component/search";
import PartsInventory from "../component/Parts-Inventory";
import Pagination from "../component/Pagination";
import PageSizeSelect from "../component/PageSizeSelect";
import "../component/css/listing-table.css";
import axios from "axios";

function Inventorylist() {
  const [manufacturers, setManufacturers] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [searchFilled, setSearchFilled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [totalProducts, setTotalProducts] = useState(0);

  const [iframeHeight, setIframeHeight] = useState(0);
  const [selectedManufacturer, setSelectedManufacturer] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [equipmentList, setEquipmentList] = useState([]);

  const fetchManufacturers = async () => {
    try {
      const response = await axios.get(
        "/server/manufacturer-list/manufacturer-list-details"
      );
      setManufacturers(response.data);
      fetchModelList();
    } catch (error) {
      console.error("Error fetching manufacturers:", error.message);
    }
  };

  const fetchModelList = async () => {
    try {
      const response = await axios.get(
        "/server/manufacturer-list/model-list-details"
      );
      setModelList(response.data);
    } catch (error) {
      console.error("Error fetching model list:", error.message);
    }
  };

  const fetchData = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/server/manufacturer-list/part-listings-details",
        {
          params: {
            keyword: searchInput,
            manufacturer: selectedManufacturer,
            model: selectedModel,
            page: page,
            limit: pageSize,
          },
        }
      );
      const responseData = response.data;
      setLoading(false);
      if (responseData.error) {
        console.error("Error fetching data:", responseData.error);
        setNoResults(true);
        setEquipmentList([]);
      } else {
        if (Array.isArray(responseData.message)) {
          setEquipmentList(responseData.message);
          setTotalProducts(responseData.TotalProducts);
          setNoResults(responseData.message.length === 0);

          console.log("+++++++++++Total Products List===", responseData);
        } else {
          console.error("Invalid data format:", responseData);
          setNoResults(true);
          setEquipmentList([]);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  const sendIframeHeightToParent = () => {
    const newIframeHeight = document.body.scrollHeight;
    setIframeHeight(newIframeHeight);
    console.log("Sending iframe height:", newIframeHeight);
    window.parent.postMessage(
      { messageType: "iframeHeight", data: newIframeHeight },
      "*"
    );
  };

  useEffect(() => {
    fetchManufacturers();
  }, []);

  useEffect(() => {
    sendIframeHeightToParent();
  }, [totalProducts]);

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, searchInput, selectedManufacturer, selectedModel, pageSize]);

  const handleSearchInputChange = (query) => {
    const formattedQuery = query.replace(/ /g, "%20");
    setSearchInput(formattedQuery);
    setCurrentPage(1);
  };

  const handleManufacturerChange = (manufacturer) => {
    const formattedManufacturer = manufacturer.replace(/\s+/g, "%20");
    setSelectedManufacturer(formattedManufacturer);
    setCurrentPage(1);
  };

  const handleModelChange = (model) => {
    const formattedModel = model.replace(/\s+/g, "%20");
    setSelectedModel(formattedModel);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setSearchInput("");
    setSelectedManufacturer("");
    setSelectedModel("");
    setCurrentPage(1);
  };

  const equipmentDataHtml =
    equipmentList.length > 0 ? (
      equipmentList.map((value) => (
        <PartsInventory
          key={value.JAD_ID}
          jad_id={value.JAD_ID}
          description={value.Product_Description}
          model={value.Model}
          Manufacturer={value.Manufacturer_Id}
          data={value}
          thumb={value.thumb}
          Inspection_Available={value.Is_Inspection_Available}
          vintage={value.Vintage}
          Condition={value.Condition}
          Parts_number={value["Part Number"]}
          Revision={value.Revision}
        />
      ))
    ) : (
      <tr>
        <td colSpan={6} className="listing-empty">
          No parts found matching your search criteria.
        </td>
      </tr>
    );

  const paginationComponent = (
    <Pagination
      onPageChange={setCurrentPage}
      currentPage={currentPage}
      total={totalProducts}
      pageSize={pageSize}
    />
  );

  const embedded = isEmbedMode();
  return (
    <>
      {!embedded && <TopHeader />}
      {!embedded && <Secondheader />}
      <div className="banner-image banner-image-part">
        <h1>Parts Inventory</h1>
      </div>
      <div className="filter-header-container">
        <div className="filter-container">
          <SelectedOption
            name="Manufacturer"
            values={manufacturers["Manufacturer"]}
            searchfunction={handleManufacturerChange}
            searchvalue={selectedManufacturer}
            type="single"
          />
          <SelectedOption
            name="Model"
            values={modelList["models"]}
            searchfunction={handleModelChange}
            searchvalue={selectedModel}
            type="single"
          />
          <button
            onClick={clearFilters}
            className={`clear-all-btn ${
              searchInput === "" &&
              selectedManufacturer === "" &&
              selectedModel === ""
                ? "d-none"
                : ""
            }`}
          >
            {searchFilled ? "Clear Search" : "Clear All Filters"}
          </button>

          <Search
            value={searchInput}
            searchfunction={handleSearchInputChange}
            setsearchfill={() => setSearchFilled(true)}
            setsearchempty={() => setSearchFilled(false)}
          />
        </div>
      </div>
      <div className="listing-table-wrap">
        <table className="listing-table">
          <colgroup>
            <col style={{ width: "13%" }} />
            <col style={{ width: "29%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "14%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>Parts</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Part Number</th>
              <th>Revision</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="listing-empty">
                  <div className="spinner"></div>
                </td>
              </tr>
            ) : (
              equipmentDataHtml
            )}
          </tbody>
        </table>
      </div>

      {!loading && (
        <div className="listing-footer">
          <div className="listing-footer-left">
            {totalProducts > 0 && (
              <span className="listing-count">
                Showing{" "}
                {`${(currentPage - 1) * pageSize + 1}-${Math.min(
                  currentPage * pageSize,
                  totalProducts
                )}`}{" "}
                of {totalProducts}
              </span>
            )}
            <PageSizeSelect value={pageSize} onChange={handlePageSizeChange} />
          </div>
          {paginationComponent}
        </div>
      )}
    </>
  );
}
export default Inventorylist;
